var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletAdded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C12.2105 1.6665 14.3301 2.54448 15.8929 4.10728C17.4557 5.67008 18.3337 7.7897 18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984ZM9.77533 13.0082L13.5837 8.00817V7.98317C13.7653 7.74499 13.806 7.42802 13.6906 7.15165C13.5751 6.87529 13.321 6.68151 13.0239 6.64332C12.7268 6.60513 12.4319 6.72833 12.2503 6.9665L9.10033 11.1332L7.74199 9.39984C7.55889 9.16464 7.26423 9.04499 6.96899 9.08595C6.67375 9.12692 6.42279 9.32229 6.31065 9.59845C6.19851 9.87462 6.24223 10.1896 6.42533 10.4248L8.45866 13.0165C8.61768 13.2177 8.86051 13.3346 9.11699 13.3332C9.37491 13.3326 9.618 13.2125 9.77533 13.0082Z",
    fill: "#ADCB53"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletAdded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_added.c376834b5ec66ccbe39eb47db5b42660.svg";